import React from 'react';

import {Handler, HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ScrollerMoreStatuses} from '../../../../srcCommon/scroll/scrollerTypes';
import {SelectedColumnSort} from './tableColumn';
import {VirtualTableBase, VirtualTableInheritableProps} from './virtualTableBase';

/*
 * Props.
 */

export interface StaticVirtualTableProps<T> extends VirtualTableInheritableProps<T> {
  hasData: boolean;
  shouldRenderEmptyState: boolean;
  onSortUpdate?: HandlerOf<SelectedColumnSort>;
  moreStatuses: ScrollerMoreStatuses;
  onLoadMore: Handler;
}

/*
 * Component.
 */

export const StaticVirtualTable = <T extends {}>(props: StaticVirtualTableProps<T>) => {
  const {
    columns,
    sortableColumns,
    sortedColumn,
    bottomPadding,
    size,
    items,
    shouldAllowMultiSelect,
    isInMultiSelectMode,
    renderRow,
    renderEmpty,
    renderMultiSelectHeader,
    onMultiSelectHeaderChange,
    hasData,
    onSortUpdate,
    shouldRenderEmptyState,
    moreStatuses,
    onLoadMore,
  } = props;

  return (
    <VirtualTableBase
      columns={columns}
      sortedColumn={sortedColumn}
      sortableColumns={sortableColumns}
      items={items}
      size={size}
      shouldAllowMultiSelect={shouldAllowMultiSelect}
      isInMultiSelectMode={isInMultiSelectMode}
      renderRow={renderRow}
      renderEmpty={renderEmpty}
      renderMultiSelectHeader={renderMultiSelectHeader}
      onMultiSelectHeaderChange={onMultiSelectHeaderChange}
      bottomPadding={bottomPadding}
      shouldRenderEmptyState={shouldRenderEmptyState}
      computeMoreStatuses={() => moreStatuses}
      onLoadMore={onLoadMore}
      hasData={hasData}
      onSortUpdate={onSortUpdate}
    />
  );
};
